import './loadingscreen.css';
import AnimatedLogo from './AnimatedLogo';

/**
 * Полноэкранный экран загрузки с анимированным лого
 */
export default function LoadingScreen() {
    return (
        <div className="loading-screen">
            <div className="loading-screen-content">
                <div className="loading-screen-logo">
                    <AnimatedLogo size="large" />
                </div>
            </div>
        </div>
    );
}
